module.exports = __webpack_public_path__ + "img/portugal-external-causes-male.b3a1d8d9.png";